// Single post page specific JavaScript entry point
// Add imports and code for single post pages only below
import './gsap';
import './google';
import './gallery-lightbox';
import './tabs';

import { SliderTracks } from './slider-tracks';
const carouselElement = document.querySelector('.related-posts-carousel.variable-width');
if (carouselElement) {
 new SliderTracks(
 	{
 		elementSelector: '.related-posts-carousel.variable-width',
 		pixelChange: 1,
 		intervalSpeedMS: 20,
 		timeToTransitionMS: 1000
 	}
 );
}
